// config.js
const apiUrl = 'https://kitchenmela.onrender.com'; // Replace with your actual API base URL
export default apiUrl;
   
